import { render } from "./EyeIcon.vue?vue&type=template&id=5bfa5b24"
import script from "./EyeIcon.vue?vue&type=script&lang=js"
export * from "./EyeIcon.vue?vue&type=script&lang=js"
script.render = render

export default script